<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  @import "~toastr/toastr";
  @import "main.scss";
  @import "~@trendyol-js/grace/css/root";
  @import "~@trendyol-js/grace/css/system";
</style>
